import { OrderState } from '#components/shared/OrderState.tsx';
import type { OrderStatus } from '#domain/Order.ts';
import type { StopType } from '#domain/Stop.ts';
import type { StopStatus } from '#domain/StopStatus.ts';

export const StopAndOrderStatus = ({
    stopStatus,
    stopType,
    orderStatus,
}: {
    stopStatus?: StopStatus;
    stopType?: StopType;
    orderStatus?: OrderStatus;
}) => {
    if (stopStatus === 'finished') {
        return <OrderState status={'finished'} />;
    }
    const shouldShowOrderStatus =
        orderStatus === 'finished' ||
        orderStatus === 'in-transit' ||
        (stopType === 'load' && orderStatus === 'loading') ||
        (stopType === 'unload' && orderStatus === 'unloading');
    if (shouldShowOrderStatus) {
        return <OrderState status={orderStatus} />;
    }
    return null;
};
